import AxiosInstance from "./api";

export const InvestmentJointVentureDifferentialAllocationRecordService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/investment-joint-venture-differential-allocation-record/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/investment-joint-venture-differential-allocation-record/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/investment-joint-venture-differential-allocation-record", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/investment-joint-venture-differential-allocation-record/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/investment-joint-venture-differential-allocation-record/" + id);
  },
};
